/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

import Vue from 'vue';
window.Vue = require('vue');
window.Vapor = require('laravel-vapor');

// Install BootstrapVue
import { BootstrapVue } from 'bootstrap-vue'
Vue.use(BootstrapVue)

// Install Notifications
import VueToast from 'vue-toast-notification';
Vue.use(VueToast, {
    position: 'top-right',
    duration: 5000
});

// Install Multi Select
import Multiselect from 'vue-multiselect'
Vue.component('multiselect', Multiselect)

// Install MomentJs
const moment = require('moment-timezone')
require('moment/locale/pt-br')
Vue.use(require('vue-moment'), {
    moment
})

// Install Vue2Filters
import Vue2Filters from 'vue2-filters'
Vue.use(Vue2Filters)

// Install Chart Google
import VueGoogleCharts from 'vue-google-charts'
Vue.use(VueGoogleCharts)

// Install Mask
import VueTheMask from 'vue-the-mask'
Vue.use(VueTheMask)

// Install Money
import money from 'v-money'
Vue.use(money, {precision: 2})

import VueTour from 'vue-tour'
require('vue-tour/dist/vue-tour.css')
Vue.use(VueTour)
// HasError
Vue.mixin(require('./mixins/hasErrors'))
Vue.mixin(require('./mixins/setErrors'))
Vue.mixin(require('./mixins/redirectIfNeed'))

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Components
 */
Vue.component('has-errors', require('./components/HasError').default);
Vue.component('section-default', require('./components/SectionDefault').default);
Vue.component('school-register', require('./pages/School.vue').default);
Vue.component('onboarding-page', require('./pages/Onboarding.vue').default);
Vue.component('s3-file-input', require('./components/S3FileInput').default);
Vue.component('side-menu-tour', require('./components/SideBarTour.vue').default);

/**
 * Student
 */
Vue.component('student-notifications', require('./pages/student/Notifications').default);
Vue.component('student-dashboard', require('./pages/student/dashboard/Index').default);
Vue.component('student-drop-down-group', require('./pages/student/DropDownGroup').default);
Vue.component('student-group-create-enter-group', require('./pages/student/group/CreateEnterGroup').default);
Vue.component('student-configuration-basic-profile', require('./pages/student/configuration/BasicProfile').default);
Vue.component('student-configuration-password-profile', require('./pages/student/configuration/PasswordProfile').default);
Vue.component('student-configuration-destroy-account', require('./pages/student/configuration/DestroyAccount').default);
Vue.component('student-configuration-address', require('./pages/student/configuration/AdressInformation').default);

Vue.component('student-themes-index', require('./pages/student/themes/Index').default);

Vue.component('student-essays-index', require('./pages/student/essays/Index').default);
Vue.component('student-essays-create', require('./pages/student/essays/Create').default);
Vue.component('student-essays-create-write', require('./pages/student/essays/CreateWrite').default);
Vue.component('student-essays-correction', require('./pages/student/essays/Correction').default);
Vue.component('student-essays-resend', require('./pages/student/essays/Resend').default);
Vue.component('student-essays-correction-text', require('./pages/student/essays/CorrectionText').default);


Vue.component('student-essays-annotations', require('./pages/student/essays/CorrectionComponents/ContentImgNew').default);

Vue.component('student-reports-overview', require('./pages/student/reports/Overview').default);
Vue.component('student-reports-ranking', require('./pages/student/reports/ranking/Index').default);

Vue.component('student-tasks-index', require('./pages/student/tasks/Index').default);

Vue.component('student-courses-index', require('./pages/student/courses/Index').default);
Vue.component('student-course-modules-index', require('./pages/student/course-modules/Index').default);
Vue.component('student-course-lesson-index', require('./pages/student/course-lesson/Index').default);

Vue.component('student-auth-login', require('./pages/student/auth/Login').default);

Vue.component('student-test', require('./pages/student/Test').default);

/**
 * Teacher
 */
Vue.component('teacher-notifications', require('./pages/teacher/Notifications').default);
Vue.component('teacher-dashboard', require('./pages/teacher/dashboard/index').default);
Vue.component('teacher-organization-create-new-organization', require('./pages/teacher/organization/CreateNewOrganization').default);
Vue.component('teacher-organization-create-enter-organization', require('./pages/teacher/organization/CreateEnterOrganization').default);
Vue.component('teacher-drop-down-organization', require('./pages/teacher/DropDownOrganization').default);
Vue.component('teacher-configuration-basic-profile', require('./pages/teacher/configuration/BasicProfile').default);
Vue.component('teacher-configuration-password-profile', require('./pages/teacher/configuration/PasswordProfile').default);
Vue.component('teacher-configuration-organization', require('./pages/teacher/configuration/Organization').default);
Vue.component('teacher-configuration-address', require('./pages/teacher/configuration/AdressInformation').default);

Vue.component('teacher-groups-index', require('./pages/teacher/groups/Index').default);

Vue.component('teacher-pre-comments-index', require('./pages/teacher/pre-comments/Index').default);

Vue.component('teacher-pre-observations-index', require('./pages/teacher/pre-observations/Index').default);

Vue.component('teacher-students-index', require('./pages/teacher/students/Index').default);

Vue.component('teacher-teachers-index', require('./pages/teacher/teachers/Index').default);

Vue.component('teacher-themes-index', require('./pages/teacher/themes/Index').default);
Vue.component('teacher-themes-create', require('./pages/teacher/themes/Create').default);
Vue.component('teacher-themes-edit', require('./pages/teacher/themes/Edit').default);
Vue.component('teacher-themes-destroy', require('./pages/teacher/themes/Destroy').default);

Vue.component('teacher-essays-index', require('./pages/teacher/essays/Index').default);
Vue.component('teacher-essays-create', require('./pages/teacher/essays/Create').default);
Vue.component('teacher-essays-create-write', require('./pages/teacher/essays/CreateWrite').default);
Vue.component('teacher-essays-correction', require('./pages/teacher/essays/Correction').default);
Vue.component('teacher-essays-correction-text', require('./pages/teacher/essays/CorrectionText').default);

Vue.component('teacher-reports-overview', require('./pages/teacher/reports/Overview').default);
Vue.component('teacher-reports-teachers-overview', require('./pages/teacher/reports-teachers/Overview').default);
Vue.component('teacher-reports-students-sendings-overview', require('./pages/teacher/reports-students/sendings/Overview').default);
Vue.component('teacher-reports-students-ranking-overview', require('./pages/teacher/reports-students/ranking/Overview').default);

Vue.component('teacher-tasks-index', require('./pages/teacher/tasks/Index').default);
Vue.component('teacher-tasks-create', require('./pages/teacher/tasks/Create').default);
Vue.component('teacher-tasks-edit', require('./pages/teacher/tasks/Edit').default);

Vue.component('teacher-courses-index', require('./pages/teacher/courses/Index').default);
Vue.component('teacher-course-modules-index', require('./pages/teacher/course-modules/Index').default);
Vue.component('tutorials-index', require('./pages/teacher/tutorials/Index').default);
Vue.component('teacher-course-lesson-index', require('./pages/teacher/course-lesson/Index').default);

// improvements
Vue.component('teacher-improvements-index', require('./pages/teacher/improvements/Index').default);
// Subscription
Vue.component('teacher-subscriptions-index', require('./pages/teacher/subscription/Index').default);
Vue.component('teacher-plans-index', require('./pages/teacher/subscription/plans/Index').default);

// Pagarme
Vue.component('teacher-pagarme-manager', require('./pages/teacher/pagarme/Manager').default);
Vue.component('teacher-pagarme-checkout', require('./pages/teacher/pagarme/Checkout').default);

// Integration
Vue.component('teacher-integration-index', require('./pages/teacher/integration/Index').default);

// auth
Vue.component('teacher-auth-login', require('./pages/teacher/auth/Login').default);
Vue.component('teacher-test', require('./pages/teacher/Test').default);

Vue.component('stripe-alert', require('./components/StripeAlert').default);
Vue.component('asaas-alert', require('./components/AsaasAlert').default);
Vue.component('address-alert', require('./components/AddressAlert').default);
Vue.component('app-alert', require('./components/AppAlert').default);
Vue.component('email-alert', require('./components/VerifyEmailAlert').default);
Vue.component('student-limit-alert', require('./components/StudentLimitAlert').default);


Vue.component('teacher-reviews-index', require('./pages/teacher/reviews/Index.vue').default);

/**
 * Admin
 */
Vue.component('admin-teachers-index', require('./pages/admin/teachers/Index').default);
Vue.component('admin-students-index', require('./pages/admin/students/Index').default);
Vue.component('admin-organizations-index', require('./pages/admin/organizations/Index').default);

/**
 * Site
 */
Vue.component('school-register', require('./pages/School.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// Sentry
/*
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
Sentry.init({
    Vue,
    dsn: "https://b991c2b35ab64f779f504febdda0205d@o4504933164580864.ingest.sentry.io/4505307107098624",
    integrations: [new Integrations.BrowserTracing()],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    // tracesSampleRate: 1.0,
});

if (window.user) {
    Sentry.setUser({
        username: window.user.name || 'Desconhecido',
        email: window.user.email || 'desconhecido@ecorrecao.com.br',
    })
}
*/

const app = new Vue({
    el: '#app',
});
